
export default {
  destroyed () {
    this.$store.dispatch('teardownTimer');
  },
};
